export const affiliateTypex = [
{id: 6119, name: "ATTESTEE", description: "ATTESTEE"},
{id: 6120, name: "PROPRIETOR_MINOR", description: "PROPRIETOR_MINOR"},
{id: 6121, name: "PROPRIETOR_COMPANY", description: "PROPRIETOR_COMPANY"},
{id: 6122, name: "PROPRIETOR", description: "PROPRIETOR"},
{id: 6986, name: "DIRECTOR", description: "DIRECTOR"},
{id: 6987, name: "CHARTERED_ACCOUNTANT", description: "CHARTERED_ACCOUNTANT"},
{id: 6988, name: "LAWYER", description: "LAWYER"},
{id: 6989, name: "CHARTERED_SECRETARY", description: "CHARTERED_SECRETARY"},
{id: 7514, name: "PRESENTER", description: "PRESENTER"},
{id: 7515, name: "SECRETARY", description: "SECRETARY"},
{id: 7516, name: "SHAREHOLDER", description: "SHAREHOLDER"},
{id: 7517, name: "TRUSTEE", description: "TRUSTEE"},
{id: 7518, name: "TRUSTEE_SECRETARY", description: "TRUSTEE_SECRETARY"},
{id: 7600, name: "MEMBER", description: "MEMBER"},
{id: 7520, name: "NON_ACCREDITED_PRESENTER", description: "NON ACCREDITED PRESENTER"},
{id: 7527, name: "RECEIVER_MANGER", description: "RECEIVER_MANGER"},
{id: 7528, name: "ACCREDITED_PRESENTER", description: "ACCREDITED PRESENTER"},
{id: 7529, name: "SECRETARY_COMPANY", description: "COMPANY SECRETARY"},
{id: 7531, name: "SHAREHOLDER_CORPORATE_ENTITY", description: "SHAREHOLDER_CORPORATE_ENTITY"},
{id: 7532, name: "SHAREHOLDER_FOREIGN_ORGANISATION", description: "SHAREHOLDER_FOREIGN_ORGANISATION"},
{id: 7533, name: "SHAREHOLDER_GOVERNMENT_ORGANISATION", description: "SHAREHOLDER_GOVERNMENT_ORGANISATION"},
{id: 7537, name: "DEPONENT", description: "DEPONENT"},
{id: 7538, name: "Unused", description: "PERSON WITH SIGNIFICANT CONTROL"},
{id: 7541, name: "CHAIRMAN", description: "CHAIRMAN"},
{id: 7542, name: "GUARANTOR", description: "GUARANTOR"},
{id: 7543, name: "PSC", description: "PERSONS WITH SIGNIFICANT CONTROL"},
{id: 7544, name: "MINOR_DIRECTOR", description: "MINOR_DIRECTOR"},
{id: 7545, name: "LIQUIDATOR", description: "LIQUIDATOR"},
{id: 7546, name: "WITNESS", description: "WITNESS"},
{id: 7560, name: "NONE", description: "NONE"},
{id: 7561, name: "NONE2", description: "NONE2"},
{id: 7547, name: "LIMITED_PARTNER", description: "LIMITED PARTNER - LIMITED PARTNHERSHIP"},
{id: 7548, name: "GENERAL_PARTNER", description: "GENERAL PARTNER - LIMITED PARTNHERSHIP"},
{id: 7519, name: "PARTNER_LLP", description: "PARTNER - LIMITED LIABILITY PARTNERSHIP"},
{id: 7551, name: "PARTNER_LP", description: "PARTNER - LIMITED PARTNERSHIP"},
{id: 7554, name: "MINOR_GENERAL_PARTNER", description: "MINOR_GENERAL_PARTNER"},
{id: 7553, name: "MINOR_LIMITED_PARTNER", description: "MINOR_LIMITED_PARTNER"},
{id: 7552, name: "MINOR_LLP_PARTNER", description: "MINOR_LLP_PARTNER"},
{id: 7558, name: "SUBSCRIBER_FOREIGN_ORGANISATION", description: "SUBSCRIBER_FOREIGN_ORGANISATION"},
{id: 7557, name: "SUBSCRIBER_CORPORATE_ENTITY", description: "SUBSCRIBER_CORPORATE_ENTITY"},
{id: 7559, name: "SUBSCRIBER_GOVERNMENT_ORGANISATION", description: "SUBSCRIBER_GOVERNMENT_ORGANISATION"},
{id: 7556, name: "SUBSCRIBER", description: "SUBSCRIBER"}
];

export const affiliateTypeImmutable = JSON.parse(JSON.stringify(affiliateTypex));
export const affiliateType: any[] = affiliateTypex.sort((a, b) => {
    if (a.name > b.name) {
      return 1;
    }
    if (a.name < b.name) {
      return -1;
    }
    return 0;
  })

export const affiliateTypesById = (id:any) => {
  return affiliateTypex.find(a => `${a.id}` === `${id}`);
}
